// import _ from 'lodash'
import ItObjectsApi from '@/api/itObjectsApi'
// import SmarttenderApi from '@/api/smarttenderApi'
const objectsApi = new ItObjectsApi()
// const tenderApi = new SmarttenderApi()
import Vue from 'vue'
//import state from '../state'

export default {
  async changeCurrentOrganization({state, commit, dispatch}, payload) {
    if (state.currentOrganization != payload.currentOrganization) {
      // dispatch('clearAvailableOrganizations')
      sessionStorage.removeItem('OrganizationItId')
      commit('clearAvailableOrganizations', payload)
      commit('setCurrentOrganization', payload.currentOrganization)
      await dispatch('setSettings', payload)
    }
  },
  clearObjectData({state}, payload) {

    payload.acl.change('load')

    state.current_user.id = null
    state.resources = []
    state.tenderContactPersons = []
    state.biddingTypes = []
    state.tenderResources = {}
    state.contractNumberAndTariff = null
    // state.subcategories = []
    state.resourceGroups = []
    state.settings = {}
    // state.currentOrganization = {}
    state.favlists = []
    state.applications = []
    state.acceptors = []
    state.catalog = []
    state.cartItems = []
    state.tenders = []
    state.prolongationRule = []
    state.createOrdersUsers = []
    state.personal_manager = null
    state.stop_list = []
    state.childListOrganizators = []
    state.availableOrganizationsForCurrently = []
    state.departments = []
    state.availableCards = []
    state.accreditedSuppliers = []
  },
  async getUsers( comntext, userIds, userLogins) {
    let user_ids = userIds || userLogins
    if (!user_ids?.length) { return [] }
    let users =  Vue.prototype.$store.getters['getUsers'],
      user = users?.filter(el => {
        return el && user_ids?.length ? user_ids.find(it => it?.trim() == el.id?.trim() || el.user?.userId?.trim() ) : false
      })
    if (user?.length) {
      return user
    }
    return await objectsApi.getUsers(userIds, userLogins)
  },
  async personalManagerContacts({state, commit}, payload ) {
    let personal_manager = state.personal_manager
    if ( !personal_manager?.fullName || payload) {
      return await objectsApi.personalManagerContacts()
        .then(res => {
          commit('setPersonalManagerContacts', res)
          return res
        })
    } else {
      return personal_manager
    }

  },
  async availableOrganizationsForCurrently({state, commit}, payload ) {
    let orgs = state.availableOrganizationsForCurrently
    if ( !orgs?.length || payload) {
      return await objectsApi.availableOrganizationsForCurrently()
        .then(res => {
          commit('setAvailableOrganizationsForCurrently', res)
          return res || []
        })
    } else {
      return orgs
    }

  }
}
